import { render, staticRenderFns } from "./MediaCenter.form.vue?vue&type=template&id=2ff64789&scoped=true&lang=pug&"
import script from "./MediaCenter.form.vue?vue&type=script&lang=ts&"
export * from "./MediaCenter.form.vue?vue&type=script&lang=ts&"
import style0 from "./MediaCenter.form.vue?vue&type=style&index=0&id=2ff64789&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff64789",
  null
  
)

export default component.exports